import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/components/common/SeeMoreButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/components/containers/Articles/ArticlesCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
